export default "__VITE_PUBLIC_ASSET__30798b49__"